export default Object.freeze({
    BASIC: 1,
    GOLD: 2,
    PLATINUM: 3,
    DIAMOND: 4,
})